// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageViews__container-dba920 {
  --mv-color: var(--chat-bubble-text-secondary);
  --mv-ic-color: var(--chat-bubble-text-secondary);
  color: var(--mv-color);
  font: var(--font-caption-1);
  letter-spacing: var(--font-spacing-caption-1);
}

.MessageViews__fixed-color-cd9502 {
  --mv-color: var(--addition-50);
  --mv-ic-color: var(--addition-50);
}

.MessageViews__content-c375c8 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.MessageViews__icon-d8921f {
  width: 16px;
  height: 16px;
  margin-inline-end: 5px;
  margin-top: -1px;
  fill: var(--mv-ic-color);
}

.MessageViews__can-show-pointer-decd6b {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/MessageViews/MessageViews.styles.m.css"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,gDAAA;EACA,sBAAA;EACA,2BAAA;EACA,6CAAA;AACF;;AAEA;EACE,8BAAA;EACA,iCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,wBAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".container {\n  --mv-color: var(--chat-bubble-text-secondary);\n  --mv-ic-color: var(--chat-bubble-text-secondary);\n  color: var(--mv-color);\n  font: var(--font-caption-1);\n  letter-spacing: var(--font-spacing-caption-1);\n}\n\n.fixed-color {\n  --mv-color: var(--addition-50);\n  --mv-ic-color: var(--addition-50);\n}\n\n.content {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n  margin-inline-end: 5px;\n  margin-top: -1px;\n  fill: var(--mv-ic-color);\n}\n\n.can-show-pointer {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MessageViews__container-dba920`,
	"fixed-color": `MessageViews__fixed-color-cd9502`,
	"fixedColor": `MessageViews__fixed-color-cd9502`,
	"content": `MessageViews__content-c375c8`,
	"icon": `MessageViews__icon-d8921f`,
	"can-show-pointer": `MessageViews__can-show-pointer-decd6b`,
	"canShowPointer": `MessageViews__can-show-pointer-decd6b`
};
module.exports = ___CSS_LOADER_EXPORT___;
